import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import {
  CreateStorageForm,
  CreateStorageResult,
} from "../Forms/CreateStorageForm";
import { StorageCaseInfoInput, StorageFormData } from "../storage.types";

interface CopyStorageModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (result?: CreateStorageResult) => void;
  onCancel: () => void;
  copyFromData: StorageFormData;
  caseInfo?: StorageCaseInfoInput;
}

export const CopyStorageModal: FC<CopyStorageModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  copyFromData,
  caseInfo,
}) => {
  const handleSubmit = (result?: CreateStorageResult) => {
    onSubmit?.(result);
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <>
      <Modal open={show} onClose={onClose}>
        <CreateStorageForm
          width={700}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          copyFromData={copyFromData}
          caseInfo={caseInfo}
        />
      </Modal>
    </>
  );
};
